import { Theme } from '@mui/material/styles'

// ----------------------------------------------------------------------

export default function Dialog(theme: Theme) {
  return {
    MuiDialog: {
      styleOverrides: {
        root: {
          zIndex: 2000000001,
        },
        paper: {
          boxShadow: theme.shadows[24],
          '&.MuiPaper-rounded': {
            // Concentric corners: outer radius = inner element's radius + the
            // gap between them. The nearest corner element is the CTA pill in
            // DialogActions: 32px tall (default size) → radius 16, sitting 16px
            // (spacing(2)) from the edge → 16 + 16 = 32. This assumes a
            // default-size CTA; a size="large" button (44px tall → radius 22)
            // in the action row would need this re-derived (22 + 16 = 38). If
            // visual review reads it as toy-like, clamp here and update this
            // arithmetic.
            borderRadius: 32,
          },
          '&.MuiDialog-paperFullScreen': {
            borderRadius: 0,
            // MUI sets margin: 0 for a full screen paper, but the small-screen margin below
            // overrides it and leaves the dialog inset by a spacing unit on every side -- which
            // is exactly the room a full screen dialog was opened to get.
            margin: 0,
            maxHeight: '100%',
          },
          '&.MuiDialog-paper .MuiDialogActions-root': {
            padding: theme.spacing(2),
          },
          '@media (max-width: 600px)': {
            margin: theme.spacing(2),
          },
          '@media (max-width: 663.95px)': {
            '&.MuiDialog-paperWidthSm.MuiDialog-paperScrollBody': {
              maxWidth: '100%',
            },
          },
        },
        paperFullWidth: {
          width: '100%',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: theme.spacing(2.5, 3, 2),
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0, 3, 2.5),
        },
        dividers: {
          borderTop: 0,
          borderBottomStyle: 'dashed',
          paddingBottom: theme.spacing(3),
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          // In a dialog tall enough to hit its max height this row was
          // compressed from 84px to 64px, which pushed the CTA outside its own
          // padding — 14px from the bottom edge against 24px on the right.
          flexShrink: 0,
          '& > :not(:first-of-type)': {
            marginLeft: theme.spacing(1.5),
          },
        },
      },
    },
  }
}
